// # Progress Bar Component for Signup Steps
import React from 'react';
import './progress_bar.css';

const SignupProgress = ({ currentStep }) => {
  const steps = [
    { number: 2, label: 'Personal Information' },
    { number: 3, label: 'Academic Information' },
    { number: 4, label: 'Profile Photo' }
  ];

  return (
    <div className="pgrs_br_signup-progress">
      <div className="pgrs_br_progress-bar">
        <div 
          className="pgrs_br_progress-fill"
          style={{ width: `${((currentStep - 2) / 2) * 100}%` }}
        />
      </div>
      <div className="pgrs_br_progress-steps">
        {steps.map((step) => (
          <div 
            key={step.number}
            className={`pgrs_br_progress-step ${currentStep >= step.number ? 'active' : ''}`}
          >
            <div className="pgrs_br_step-number">{step.number}</div>
            <div className="pgrs_br_step-label">{step.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SignupProgress;
